module.exports = __webpack_public_path__ + "static/media/girl2.1d8e8d6f.jpg";